import React, { createContext, useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const LanguageContext = createContext(null);

// RTL languages
const RTL_LANGUAGES = ['ar', 'he'];

export const LanguageProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language || 'en');
  const [isRTL, setIsRTL] = useState(RTL_LANGUAGES.includes(i18n.language || 'en'));

  // Update HTML attributes when language changes
  useEffect(() => {
    const lang = currentLanguage || 'en';
    const rtl = RTL_LANGUAGES.includes(lang);
    
    document.documentElement.lang = lang;
    document.documentElement.dir = rtl ? 'rtl' : 'ltr';
    setIsRTL(rtl);
    
    // Update body class for RTL styling
    if (rtl) {
      document.body.classList.add('rtl');
    } else {
      document.body.classList.remove('rtl');
    }
  }, [currentLanguage]);

  const changeLanguage = useCallback(async (lang) => {
    try {
      await i18n.changeLanguage(lang);
      setCurrentLanguage(lang);
      localStorage.setItem('rodbot_language', lang);
    } catch (error) {
      console.error('Error changing language:', error);
    }
  }, [i18n]);

  // Initialize language from storage
  useEffect(() => {
    const savedLang = localStorage.getItem('rodbot_language');
    if (savedLang && savedLang !== currentLanguage) {
      changeLanguage(savedLang);
    }
  }, []);

  const value = {
    currentLanguage,
    isRTL,
    changeLanguage,
    availableLanguages: [
      { code: 'en', name: 'English', nativeName: 'English' },
      { code: 'ar', name: 'Arabic', nativeName: 'العربية' },
      { code: 'he', name: 'Hebrew', nativeName: 'עברית' },
    ],
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

